const trackButtonClickHandler = (event) => {
  const { trackCategory, trackAction, trackName, trackSource } = event.currentTarget.dataset
  if (window._paq) {
    let trackDescription = 'Click en ' + trackName
    if (trackSource)
      trackDescription += ' desde ' + trackSource
    window._paq.push(['trackEvent', trackCategory, trackAction, trackDescription])
  }
}

export { trackButtonClickHandler }
